<template>
	<div id="signup">
		<WordpressContentPage 
			:pageSlug="'sign-up-gold'"
			v-if="showGold"
		/>
		<WordpressContentPage 
			:pageSlug="'sign-up'"
			v-else
		/>
		<div 
			id="signup-form" 
			class="row justify-content-md-center"
		>
		<div class="col-12 col-md-6 col-xl-4">
			<!-- <h1>Sign up with Cherrytree</h1> -->
			<!-- TODO: CMS wording signup -->
			<h5 v-if="available_silver_memberships > 1" class="signUpMessage col-12 text-center">
				Hurry! There are only {{available_silver_memberships}} spots remaining.
			</h5>
			<h5 v-else-if="available_silver_memberships == 1" class="signUpMessage col-12 text-center">
				Hurry! There is only {{available_silver_memberships}} spot remaining.
			</h5>
			<h5 v-else-if="available_silver_memberships == 0" class="signUpMessage col-12">
				<strong>We have reached capacity for now!</strong><br>
				As we launched our new BETA site, we limited the places available to 200. This was to ensure we have everything right for our full launch.<br>
				Please register to be the first notified when you are able to join in our full launch soon.
			</h5>

			<form class="signupForm row mx-auto" v-on:submit.prevent="submitSignup">
				<label class="col-12 col-sm-4">Email</label>
				<input
					v-focus
					v-model="email"
					type="text"
					name="Email"
					v-validate="'required|email|notExists'"
					class="col-12 col-sm-8 form-control"
					autocomplete="on"
				>
				<div class="invalid-feedback">{{errors.first('Email')}}</div>

				<label class="col-12 col-sm-4">Given Name</label>
				<input
					v-model="given_name"
					type="text"
					name="Given Name"
					v-validate="'required'"
					class="col-12 col-sm-8 form-control"
					autocomplete="on"
				>
				<div class="invalid-feedback">{{errors.first('Given Name')}}</div>

				<label class="col-12 col-sm-4">Family Name</label>
				<input
					v-model="family_name"
					type="text"
					name="Family Name"
					v-validate="'required'"
					class="col-12 col-sm-8 form-control"
					v-on:keyup.enter="submitSignup"
					autocomplete="on"
				>
				<div class="invalid-feedback">{{errors.first('Family Name')}}</div>


				<label class="col-12 col-sm-4">Password</label>
				<input
					v-model="password"
					type="password"
					name="Password"
					autocomplete="new-password"
					v-validate="'required|min:8'"
					ref="password"
					class="col-12 col-sm-8 form-control"
				>
				<div class="invalid-feedback">{{errors.first('Password')}}</div>

				<label class="col-12 col-sm-4">Confirm Password</label>
				<input
					v-model="confirm_password"
					type="password"
					name="Confirm Password"
					v-validate="'required|confirmed:password'"
					autocomplete="new-password"
					class="col-12 col-sm-8 form-control"
				>
				<div class="invalid-feedback">{{errors.first('Confirm Password')}}</div>

				<label class="col-12 col-sm-4">Phone</label>
				<input
					v-model="phone"
					type="tel"
					v-validate="'required'"
					name="Phone"
					class="col-12 col-sm-8 form-control"
					autocomplete="on"
				>
				<div class="invalid-feedback">{{errors.first('Phone')}}</div>
				<!-- Suppressed, TODO unsuppress when this is to implemented -->
				<!-- <label class="col-12 col-sm-4">Promo Code</label>
				<input
				v-model="promo_code"
				type="text"
				name="promo_code"
				class="col-12 col-sm-8 form-control"
				> -->

				<label class="col-8 col-sm-8">
					I accept the 
					<router-link
						:to="{name:'terms-and-conditions'}"
						target="_blank"
					>
						terms &amp; conditions*
					</router-link>
				</label>
				<!-- TODO Disable checkboxes and tie them to the change in the vuex state for pledge and T and Cs -->
				<input
					type="checkbox"
					name="Terms and Conditions"
					v-validate="'required'"
					class="col-4 col-sm-4 form-control"
					:checked="TandC"
				>
				<div class="invalid-feedback">{{errors.first('Terms and Conditions')}}</div>

				<label class="col-8 col-sm-8">
					I accept the  
					<router-link
						:to="{name:'pledge'}"
						target="_blank"
					>
						membership agreement*
					</router-link> 
					below
				</label>
				<input
					type="checkbox"
					name="Pledge"
					v-validate="'required'"
					class="col-4 col-sm-4 form-control"
					:checked="pledge"
				>
				<div class="invalid-feedback">{{errors.first('Pledge')}}</div>

				<!-- <div>
				After you have visited and accepted the T’s &amp; C’s and Pledge, just tick the boxes here to sign up
				</div> -->

				<!-- <label class="col-12 col-sm-6">I would like to recieve marketing information</label>
				<input
				v-model="marketing"
				type="checkbox"
				name="Marketing"
				class="col-12 col-sm-6 form-control"
				>
				<div class="invalid-feedback">{{errors.first('Marketing')}}</div> -->

				<div v-if="referral_code" class="row col-12">
				<label class="col-8">Referral Code</label>
				<span class="col-4">{{referral_code}}</span>

				</div>

				<ButtonWithLoading
					class="mx-auto"
					type="submit"
					:state="submitState"
					text="Sign up"
					loadingText="Signing you up"
					successText="Signed up"
					failureText="Error signing you up"
				/>
				
			</form>
			<div v-if="errors.all().length > 0" class="alert alert-danger">
				<!-- TODO strings for signup errors -->
				There are problems with your signup
				<li v-for="(error, index) in errors.all()" :key="index">{{ error }}</li>
			</div>
			<div v-if="errorMessage" v-html="errorMessage" class="alert alert-danger">
			</div>
			</div>
			<div class="col-12">
				<WordpressContentPage 
					:pageSlug="'pledge'"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import ButtonWithLoading from "@/components/buttonWithLoading";
import WordpressContentPage from "@/wordpress/WordpressContentPage";

import { postSignup } from "@/network/signupRequests";
import { fetchUserExists } from "@/network/userRequests";

import { Validator } from "vee-validate";
import { mapState } from "vuex"



export default {
	name: "Signup",
	components: {
		ButtonWithLoading,
		WordpressContentPage
	},
	data() {
		return {
			email: "",
			given_name: "",
			family_name: "",
			password: "",
			confirm_password: "",
			promo_code: "",
			phone:"",
			submitState: null,
			referral_code: this.$route.query.referral || sessionStorage.getItem("cherry_tree_referral"),
			errorMessage: null,
			pledge:false,
			TandC:false,
			type: 'silver',
		};
	},
	created() {
		this.type = this.signupType;

		//save referral code in case user navigates away before completing signup
		let referral_code = this.$route.query.referral
		if(referral_code){
			sessionStorage.setItem("cherry_tree_referral", referral_code);
			this.$gtm.trackEvent({
				event: "referralSignup",
				value: referral_code
			})
		}
		//extend validator with notExists functionality which checks for the existence of the user
		const userExists = email =>
		new Promise(resolve => {
			fetchUserExists({ email }, exists => {
				if (!exists) {
					return resolve({ valid: true }); //user doesn't exist, field is valid
				} else {
					return resolve({
						valid: false,
						// TODO: string for already member
						data: { message: `${email} is already a member, try logging in instead` } //error message
					});
				}
			});
		});

		Validator.extend("notExists", {
			validate: userExists,
			getMessage: (field, params, data) => data.message
		});
		window.addEventListener("storage", this.onStorageUpdate)

	},
	methods: {
		// onStorageUpdate(event) {
		//   if (event.key === "acceptPledge") {
		//     this.pledge = event.newValue
		//   } else if(event.key === "acceptTandC"){
		//     this.TandC = event.newValue
		//   }
		// },
		submitSignup() {
			this.$validator.validateAll().then(valid => {
				if (!valid) {
					return;

				}
				this.submitState = "loading";

				const { email, given_name, password, family_name, referral_code, promo_code, phone, type } = this;

				postSignup({ email, password, given_name, family_name, referral_code, promo_code, phone, type },
				() => { //success
					this.submitState = "success";
					// Everflow Signup Tracking
					
					EF.conversion({	"offer_id": 106,"adv1":email});
					// delay redirect so user sees success
					setTimeout(() => {
						this.$router.push({ name: "checkEmail" }); //page telling the user to check their email to complete signup
					}, 500);
				},
				error =>{
					//This should be done in the backend, so this is the hackiest way to do this TODO Remove and swap to backend, however, only temporary so remove when out of Beta
					//NOTE beta
					this.errorMessage = (this.available_silver_memberships == 0)? "<strong>We have reached capacity for now!</strong><br>As we launched our new BETA site, we limited the places available to 200. This was to ensure we have everything right for our full launch.<br>Please register to be the first notified when you are able to join in our full launch soon." : error.message || "Error with signup";
					this.submitState = "error";
					setTimeout(() => {
						this.submitState = null
					}, 3000);
				})
			});
		}
	},
	computed: {
		// available_silver_memberships(){
		//   console.log(this.$store.state.auth.available_silver)
		//   return this.$store.state.auth.available_silver
		// }
		...mapState({
			available_silver_memberships: state => state.auth.available_silver
		}),
		showGold() {
			return this.$route.name == "gold-signup";
		},
		signupType() {
			return (this.showGold) ? 'gold' : 'silver';
		}
	},
};
</script>

<style lang="scss" scoped>
.signUpMessage{
	margin-bottom: 30px;
}
.readonly {
	opacity : .50;
	filter  : alpha(opacity=50); /* IE<9 */
	cursor  : default;
	&:active, &:focus{
		outline: 0;
	}
}
</style>
